import React from 'react'

import { Typography, Box, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    primaryText: {
        fontWeight: theme.typography.fontWeightMedium,
        fontFamily: theme.typography.h1.fontFamily,
        fontSize: theme.typography.subtitle1.fontSize,
        lineHeight: theme.typography.subtitle1.lineHeight
    },
    secondaryText: {
        color: theme.palette.text.secondary
    }
}))

const Faq = ({ primaryText, secondaryText }) => {

    const classes = useStyles()

    return (
        <Box className={classes.root}>
            <Typography className={classes.primaryText}>{primaryText}</Typography>
            <Typography className={classes.secondaryText}>{secondaryText}</Typography>
        </Box>
    )
}

export default Faq